import React from 'react';
import Link from 'react-router-dom/Link';

export default ({person, children, ...props}) =>
    <Link to={`/prelegenci/${person.slug}`} {...props}>{children}</Link>;


// WEBPACK FOOTER //
// ./src/modules/People/elements/PersonLink.js